import { Box, Chip } from '@mui/joy';
import { ICellRendererParams } from 'ag-grid-community';

import { IUomConversionAuditRow } from 'companySettings/types';
import { oldQuotePartListPath } from 'quotes/routes/routePaths';
import { Color, Size, Variant } from 'theme/enums';

export const QuoteIdsCell = ({
  data,
  value,
  valueFormatted,
}: ICellRendererParams<IUomConversionAuditRow>) => {
  // Group row: show the group key the column provides, never the placeholder.
  if (!data) {
    return value ?? null;
  }

  const quoteIds = data.quoteIds ?? [];

  // Single source for the placeholder: the column's valueFormatter, which is also
  // what the exports emit.
  if (quoteIds.length === 0) {
    return valueFormatted;
  }

  return (
    <Box sx={{ alignItems: 'center', display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
      {quoteIds.map((quoteId) => (
        <Chip
          key={quoteId}
          size={Size.SM}
          variant={Variant.SOFT}
          color={Color.PRIMARY}
          slotProps={{
            // Joy only renders its interactive action slot (pointer cursor, hover and
            // the focus ring) when onClick or slotProps.action is set — a bare
            // component="a" would leave the pill tabbable but invisible on focus.
            action: {
              component: 'a',
              href: oldQuotePartListPath(quoteId),
              target: '_blank',
              rel: 'noopener noreferrer',
            },
          }}
        >
          {quoteId}
        </Chip>
      ))}
    </Box>
  );
};
